import { SubInterestCategory } from '@src/containers/QuizContainer/types';

export const businessInterestCategories: SubInterestCategory[] = [
	{
		name: 'Business Administration',
		description:
			'Learn business principles and concepts to help you make effective decisions, enhance leadership and team skills, and improve oral and written communication.',
		facet: 'Business > Business Administration',
	},
	{
		name: 'Business Analysis',
		description:
			'Learn how to use tools, methodologies, and data to define business needs and recommend solutions to business and information system problems.',
		facet: 'Business > Business Analysis',
	},
	{
		name: 'Business Management & Leadership',
		description:
			'Develop the analytical and critical communication skills to manage and lead a business and team.',
		facet: 'Business > Management & Leadership',
	},
	{
		name: 'Human Resources',
		description:
			'Master the skills needed to excel in human resource development and planning, benefits, compensation, and employee relations.',
		facet: 'Business > Human Resources',
	},
	{
		name: 'Marketing',
		description:
			'Learn strategic and tactical marketing concepts and principles. Topics include consumer behavior, research, advertising, product development, and social media.',
		facet: 'Business > Marketing',
	},
	{
		name: 'Project Management',
		description:
			'Be prepared to initiate, plan, execute, monitor, and lead projects teams to meet goals within a business environment.',
		facet: 'Business > Project Management',
	},
	{
		name: 'Social Sector Management',
		description:
			'Develop skills to manage and lead in roles focused on social good & community. Industries include healthcare, government, and non-profit organizations. ',
		facet: 'Business > Social Sector Management',
	},
	{
		name: 'All business programs',
		description: '',
		facet: 'All business programs',
	},
];
